module.exports = __webpack_public_path__ + "static/media/fingerprint.dd6bb962.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerprint.svg
// module id = 1053
// module chunks = 0